import { Component, HostBinding, Input } from '@angular/core';
import { ColumnContext } from '@legacy/common-ui-shared-interfaces';
import { ImageSettings } from '@legacy/common-ui-utility-components';
import { InnogyComponentRendering } from '@core/jss-models';
import { toScrollAnchorId } from '@innogy/utils-deprecated';

import { ComposableCardConfig } from '../composables/card/card.model';
import type {
  BasicContentVariant,
  BasicContentVariantInternal,
} from './basic-content-settings.model';
import {
  BasicContentSettings,
  BasicContentValues,
} from './basic-content-settings.model';
import { BasicContentVariantMinimalComponent } from './variants/basic-content-variant-minimal/basic-content-variant-minimal.component';
import { BasicContentVariantNgContentBetweenComponent } from './variants/basic-content-variant-ng-content-between/basic-content-variant-ng-content-between.component';
import { BasicContentVariantVerticalIconComponent } from './variants/basic-content-variant-vertical-icon/basic-content-variant-vertical-icon.component';
import { BasicContentVariantVerticalImageComponent } from './variants/basic-content-variant-vertical-image/basic-content-variant-vertical-image.component';
import { BasicContentVariantPlaceholderComponent } from './variants/basic-content-variant-placeholder/basic-content-variant-placeholder.component';

@Component({
  selector: 'wl-basic-content',
  templateUrl: './basic-content.component.html',
  standalone: true,
  imports: [
    BasicContentVariantMinimalComponent,
    BasicContentVariantNgContentBetweenComponent,
    BasicContentVariantVerticalIconComponent,
    BasicContentVariantVerticalImageComponent,
    BasicContentVariantPlaceholderComponent,
  ],
})
export class BasicContentComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() variant: BasicContentVariant | BasicContentVariantInternal =
    'minimal';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() content?: BasicContentValues;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() settings?: BasicContentSettings;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() context?: ColumnContext;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() image?: ImageSettings;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() cardConfig?: ComposableCardConfig;

  @HostBinding('attr.id') get id() {
    if (this.rendering?.uid) {
      return toScrollAnchorId(this.rendering.uid);
    }
    return '';
  }
}
